import { _ } from "libs";

import React, { useContext, FunctionComponent, useState } from "react";
import { Form, Field } from "react-final-form";

import SubPageLayout from "./subPageLayout";
import ReservationPageContext from "./reservationPageContext";
import { Voucher } from "../../../types";

const required = value => (value ? undefined : "Required");

type Values = typeof initialValues;
const initialValues = { voucherCode: "" };

type VoucherBoxProps = { voucher: Voucher; cancelVoucher: any };
const VoucherBox: FunctionComponent<VoucherBoxProps> = ({ voucher, cancelVoucher }: VoucherBoxProps) => {
	if (voucher.valid) {
		return (
			<div className="voucherBox">
				<a className="cancel" onClick={cancelVoucher} />
				<p>{_("bookingWizard.voucher.voucherApplied")}</p>
				<p className="value">
					{voucher.discount} {voucher.discountCurrency}
				</p>
			</div>
		);
	} else {
		if (voucher.invalidReason) {
			return <div className="msg error">{voucher.invalidReason}</div>;
		}
		return null;
	}
};

const VoucherEntry: FunctionComponent = () => {
	const [showButton, setShowButton] = useState(true);

	const {
		getReservationContext,
		reservation: { context },
	} = useContext(ReservationPageContext);

	const onSubmit = (values: Values): void => {
		setShowButton(false);
		getReservationContext(values);
	};

	let voucher = null;
	if (context.vouchers.length > 0) {
		voucher = context.vouchers[0];
	}

	const cancelVoucher = () => {
		setShowButton(true);
		getReservationContext({ voucherCode: "" });
	};

	return (
		<SubPageLayout title={_("bookingWizard.voucher.title")}>
			<div className="wizardBody">
				{voucher && voucher.available ? (
					voucher.valid ? (
						<VoucherBox voucher={voucher} cancelVoucher={cancelVoucher} />
					) : (
						<Form
							onSubmit={onSubmit}
							initialValues={initialValues}
							render={({ handleSubmit, submitting, pristine }) => (
								<form onSubmit={handleSubmit}>
									<div className="group">
										<Field name="voucherCode" validate={required}>
											{({ input, meta }) => (
												<div className="field">
													<label>{_("bookingWizard.voucherForm.code.label")}</label>
													<input
														{...input}
														onChange={e => {
															if (!showButton) {
																setShowButton(true);
															}
															input.onChange(e);
														}}
														className="fullWidth"
														type="text"
														placeholder=" "
													/>
													{meta.error && meta.touched && <p className="error">{meta.error}</p>}
												</div>
											)}
										</Field>
									</div>
									{!showButton ? (
										<VoucherBox voucher={voucher} cancelVoucher={cancelVoucher} />
									) : (
										<button
											type="submit"
											className="button fullWidth"
											disabled={submitting || pristine}
										>
											{_("bookingWizard.voucherForm.btnApplyVoucher.label")}
										</button>
									)}
								</form>
							)}
						/>
					)
				) : (
					<div className="msg info">{voucher?.notAvailableReason}</div>
				)}
			</div>
		</SubPageLayout>
	);
};
export default VoucherEntry;
